import React, { useEffect, useState } from "react";
import styled, { withTheme } from "styled-components";
import Tabs from './casino-tab';
import AllGames from './all-games';
import Intl from '../../common/Intl'
import { withAppContext } from 'src/store/initAppContext';
import { useLocation, useParams } from "react-router-dom";
import BlackjackSEO from "src/components/SEOComponents/BlackjackSEO";
import RouletteSEO from "src/components/SEOComponents/RouletteSEO";
import DragontigerSEO from "src/components/SEOComponents/DragontigerSEO";
import BaccaratSEO from "src/components/SEOComponents/BaccaratSEO";
import SEOContents from "src/components/SEOContents";
import EvolutionSEO from "src/components/SEOComponents/EvoSE0";
import SUPERNOWASEO from "src/components/SEOComponents/supernowaSEO";
import BetgamesSEO from "src/components/SEOComponents/betgames";
import EZUGISEO from "src/components/SEOComponents/ezugiSEO";
import Mojos7 from "src/components/SEOComponents/sevnMojos";
import SexyGamingSEO from "src/components/SEOComponents/sexyhgaming";
import ONLINECASINOSEO from "src/components/SEOComponents/onlineCasino";
import MACAWSEO from "src/components/SEOComponents/macaw";
import TVbetSEO from "src/components/SEOComponents/TVbetseo";
import SuperspadeSEO from "src/components/SEOComponents/superspadeseo";
import AgSEO from "src/components/SEOComponents/AgSeo";
import LightningRouletteSEO from "src/components/SEOComponents/LightningRouletteSEO";
import FunkyTimeSEO from "src/components/SEOComponents/FunkyTimeSEO";
import CrazyTimeSEO from "src/components/SEOComponents/CrazyTimeSEO";
import TeenpattiSEO from "src/components/SEOComponents/TeenpattiSEO";
import SevenUpDown from "src/components/SEOComponents/SevenUpDown";
import AndarBaharKM46 from "src/components/SEOComponents/AndarBaharKM46";
import BonusDice46 from "src/components/SEOComponents/BonusDiceFun88";
import CoinToss46 from "src/components/SEOComponents/CoinTossF88";
import Colorgame46 from "src/components/SEOComponents/Colorgame46";
import Jhandimunda46 from "src/components/SEOComponents/Jhandimunda46";
import TripleChance46 from "src/components/SEOComponents/TripleChange46";
import AGseo46 from "src/components/SEOComponents/AGseo46";
import Skywardf88 from "src/components/SEOComponents/Skywardf88";
import Lucky7f88 from "src/components/SEOComponents/Lucky7f88";
import Betgamesf88 from "src/components/SEOComponents/Betgamesf88";
import Crazytimef88 from "src/components/SEOComponents/Crazytimef88";
import Dragontigerf88 from "src/components/SEOComponents/Dragontiger46";
import Funkytime88 from "src/components/SEOComponents/Funkytime88";
import HindiRoulettef88 from "src/components/SEOComponents/HindiRoulettef88";
import LightningDicef88 from "src/components/SEOComponents/LightningDicef88";
import LightningRoulettef88 from  "src/components/SEOComponents/LighningRoulettef88";
import MonopolyBigballerF88 from "src/components/SEOComponents/MonopolyBigballerF88";
import MonolpolyLivef88 from "src/components/SEOComponents/MonolpolyLivef88";
import RouletteF88 from "src/components/SEOComponents/RouletteF88";
import AndarbaharF88 from "src/components/SEOComponents/AndarbaharF88";
import TeenpattiF88 from "src/components/SEOComponents/TeenpattiF88";
import XXXtremeRoluetteF88 from "src/components/SEOComponents/XXXtremeRoluetteF88";
import EzugiRouletteF88 from "src/components/SEOComponents/EzugiRouletteF88";
import SuperSpadeFun88 from "src/components/SEOComponents/SuperSpadeFun88";
import TeenPatti2020Fun88 from "src/components/SEOComponents/TeenPatti2020Fun88";
import AndarBaharFun88 from "src/components/SEOComponents/AndarBaharFun88";
import AmericanRouletteFun88 from "src/components/SEOComponents/AmericanRouletteFun88";
import EvolutionBaccaratFun88 from "src/components/SEOComponents/EvolutionBaccaratFun88";
import EvolutionBlackjackSeoFun88 from "src/components/SEOComponents/EvoBlackjack";
import EvolutionDragontigerfun88 from "src/components/SEOComponents/EvolutionDragontigerfun88";
import DreamCatherf88 from "src/components/SEOComponents/DreamCatherf88";
import EvolutionTeenpattiFun88 from "src/components/SEOComponents/EvolutionTeenpattiFun88";
import EZUGIDragonTigerFun88 from "./EZUGIDragonTigerFun88";
import EZUGIoneDayTeenPattiFun88 from "./EZUGIoneDayTeenPattiFun88";
import Speedy7Fun88 from "src/components/SEOComponents/Speedy7Fun88";
import DiceDuelFun88 from "src/components/SEOComponents/DiceDuelFun88";
import SattaMatkaFun88 from "src/components/SEOComponents/SattaMatkaFun88";
import PlayTechFun88 from "src/components/SEOComponents/PlayTechFun88";
import { filterGameData, getDamain } from "src/util/commonfun";
import { getGamesJsonData } from "src/util/gameDataLoader";
import Spinner from "src/components/common/Spinner";
// Provider Icons for Live Casino, Slot Games, Bingo, Teenpatti---------------------------------
export const allIcon = `${'/static/media/AllProviderIcon.ab512083.png'}`;
export const netentIcon = `${'/static/media/netent.png'}`;
// export const betsoftIcon = `${'/static/media/Betsofticon.png'}`;
export const tvBetIcon = `${'/static/media/tvbet_icon.png'}`;
export const superSpadeIcon = `${'/static/media/superspade.png'}`;
export const ezugiIcon = `${'/static/media/ezugi_icon.png'}`;
export const evolutionIcon = `${'/static/media/evolution_icon.png'}`;
export const bettvIcon = `${'/static/media/bettv.png'}`;
export const agIcon = `${'/static/media/amazing_gaming.png'}`;
export const supernowaIcon = `${'/static/media/supernowa.png'}`;
export const spribeIcon = `${'/static/media/spribe_icon.png'}`;
export const sexygamingIcon = `${'/static/media/sexygamingIcon.png'}`;

function CasinoTabGames(props) {
    const { app: { brandId }, theme: { config } } = props;
    const { showSeoFooterInsidePages, showSEOfooterForYolo, showSeofooterFun88 } = config;

    const location = useLocation();
    const { provider, id } = useParams();

    const [gameData, setGameData] = useState({});
    const [casinoGames, setCasinoGames] = useState([]);
    const [filteredData, setfilteredData] = useState([]);
    const [providerList, setProviderList] = useState([]);
    const [providerTab, setProviderTab] = useState([]);
    const [providerIcons, setProviderIcons] = useState([]);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState('');

    const getLastqueryString = location.pathname.split("/").pop();

    useEffect(() => {
        const loadGames = async () => {
            try {
                const data = await getGamesJsonData("casinogames", brandId);
                setGameData(data);

                const { providers = [], gameData: games = [] } = data;

                // Set providerList
                const providerCategoryList = providers.map((ele: any) => ele.category);
                setProviderList(providerCategoryList);

                // Set provider Icons tab buttons
                const iconList = providers.map((ele: any) => ({
                    id: ele.id,
                    name: <Intl langKey={ele.displayKey} />,
                    icon: ele.icon,
                }));
                setProviderIcons(iconList);

                // Set tab names
                const tabNames = iconList.map((ele: any) => ele.name);
                setProviderTab(tabNames);

                // Set games
                setCasinoGames(games);
                setfilteredData(games);
            } catch (err) {
                console.error("Failed to load game data:", err);
            } finally {
                setLoading(false);
            }
        };

        loadGames();
        window.scrollTo(0, 0);
    }, [brandId])

    const searchData = (val: any) => {
        setSearch(val);

        if (val !== "") {

            // Old Function with out the slug handle
            // let _val = val && val.replace(/[\_\-\'\s]/gi, '');
            // const filteredItems = casinoGames.filter((item) => {
            // const { game = '', catagoryName = '', type = '', slug = '' } = item;

            // // Normalize the fields by removing unwanted characters and converting to lowercase
            // const normalizedGame = game.replace(/[\_\-\'\s]/gi, '').toLowerCase();
            // const normalizedCategoryName = catagoryName.replace(/[\_\-\'\s]/gi, '').toLowerCase();
            // const normalizedType = type.replace(/[\_\-\'\s]/gi, '').toLowerCase();
            // const normalizedSlug = slug.replace(/[\_\-\'\s]/gi, '').toLowerCase();

            // // Check if the cleaned-up field values start with the normalized search value
            // return (
            //     normalizedGame.includes(_val) || 
            //     normalizedCategoryName.includes(_val) || 
            //     normalizedType.includes(_val) || 
            //     normalizedSlug.includes(_val)
            // );


            // Clean up search value and item fields for better comparison
            // let type = item.type.toLowerCase() && item.type.replace(/[\_\-\'\s]/gi, '');
            // let slug = item.slug ? item.slug.replace(/[\_\-\'\s]/gi, '') : '';
            // let category = item.catagoryName ? item.catagoryName.replace(/[\_\-\'\s]/gi, '') : '';


            // // Check if either type or slug matches the search value
            // if (type.toLowerCase().includes(_val.toLowerCase()) || slug.toLowerCase().includes(_val.toLowerCase())) {
            //     return item;
            // }
            // else if ((item.game.replace(/[\_\-\'\s]/gi, '').toLowerCase()).startsWith(_val.toLowerCase())) {
            //     //searchOn = 'catagoryName'
            //     return item;
            //   }
            //   else if ((category.toLowerCase()).startsWith(_val.toLowerCase())) {
            //     //searchOn = 'catagoryName'
            //     return item;
            //   }
            //  else {
            //     const {platformCode, ...rest } = item;
            //     console.log('AAAAA-rest',rest);
            //     console.log('AAAAAA-',Object.values(rest).join('').toLowerCase().includes(val.toLowerCase()))
            //     // Fallback: Search through all other fields in the object
            //     return Object.values([platformCode]).join('').toLowerCase().includes(val.toLowerCase());
            // }


            let _val = val && val.replace(/[\_\-\.\'\s]/gi, '').toLowerCase();
            const filteredItems = casinoGames.filter((item) => {
                const { game = '', catagoryName = '', type = '', slug = '' } = item;
                const normalizedGame = game.replace(/[\_\-\.\'\s]/gi, '').toLowerCase();
                const normalizedCategoryName = catagoryName.replace(/[\_\-\'\s]/gi, '').toLowerCase();
                const normalizedType = type.replace(/[\_\-\'\s]/gi, '').toLowerCase();

                // Additional condition added for Handle slug as either string or array
                const slugList = Array.isArray(slug) ? slug : [slug];
                const normalizedSlugs = slugList.map(s =>
                    s.replace(/[\_\-\'\s]/gi, '').toLowerCase()
                );

                return (
                    normalizedGame.includes(_val) ||
                    normalizedCategoryName.includes(_val) ||
                    normalizedType.includes(_val) ||
                    normalizedSlugs.some(s => s.includes(_val))
                );
            });

            setfilteredData(filteredItems);
        } else {
            // Reset to original data when search input is empty
            setfilteredData(casinoGames);
        }
    };

    const budgetData = () => {

    }

    let domainURL = getDamain(brandId);
    const _id = provider &&  id ? id : provider;

    return (
        <>
            {
                _id && (
                    <SEOContents
                        pageName={
                            _id === "evolution" ? "evolution"
                            : _id === 'cash-or-crash' && provider === 'evolution' ? 'evo-cashorcrash'
                            : _id === 'blackjack' && provider ==='evolution'? 'evoBlackJack'
                            : _id === 'roulette' && provider ==='evolution' ? 'evo-roulette'
                            : _id === 'lightning-roulette' && provider ==='evolution' ? 'evo-lightning-roulette'
                            : _id === 'baccarat' && provider ==='evolution' ? 'evo-baccarat'
                            : _id === 'crazy-time' && provider ==='evolution' ? 'evo-crazy-time'
                            : _id === 'dream-catcher' && provider ==='evolution' ? 'evo-dream-catcher'
                            : _id === 'fan-tan' && provider ==='evolution' ? 'evo-fan-tan'
                            : _id === 'football-studio' && provider ==='evolution' ? 'evo-football-studio'
                            
                            : _id === 'monopoly-live' && provider ==='evolution' ? 'evo-monopoly-live'
                            : _id === 'sic-bo' && provider ==='evolution' ? 'evo-sic-bo'
                            : _id === 'super-sic-bo' && provider ==='evolution' ? 'evo-super-sic-bo'
                            
                            : _id === 'first-person-blackjack' && provider ==='evolution' ? 'evo-first-person-blackjack'
                            
                            : _id === 'lucky-7' && provider === 'ezugi' ? 'ezu-lucky-7'
                            : _id === 'matka' && provider === 'ezugi' ? 'ezu-matka'
                            : _id === '32-cards' && provider === 'ezugi' ? 'ezu-32-cards'
                            : _id === 'baccarat' && provider === 'ezugi' ? 'ezu-baccarat'
                            : _id === 'bet-on-number' && provider === 'ezugi' ? 'ezu-bet-on-number'
                            : _id === 'teenpatti' && provider === 'ag' ? 'ag-teenpatti'
                            : _id === 'andar-bahar' && provider === 'ag' ? 'ag-andar-bahar'
                            : _id === 'baccarat-2' && provider === 'ag' ? 'ag-baccarat-2'
                            : _id === 'baccarat-3' && provider === 'ag' ? 'ag-baccarat-3'
                            : _id === 'black-jack-1' && provider === 'ag' ? 'ag-blackjack-1'
                            : _id === 'black-jack-2' && provider === 'ag' ? 'ag-blackjack-2'
                            : _id === 'dragon-tiger' && provider === 'ag' ? 'ag-dragon-tiger'
                            : _id === 'dice' && provider === 'betgames' ? 'betgames-dice'
                            : _id === 'blackjack' && provider === 'betgames' ? 'betgames-blackjack'
                            : _id === 'lucky-7' && provider === 'betgames' ? 'betgames-lucky-7'
                            : _id === 'lucky-6' && provider === 'betgames' ? 'betgames-lucky-6'
                            : _id === 'lucky-5' && provider === 'betgames' ? 'betgames-lucky-5'
                            : _id === 'baccarat' && provider === 'betgames' ? 'betgames-baccarat'
                            : _id === 'wheel' && provider === 'betgames' ? 'betgames-wheel'
                            : _id === 'keno' && provider === 'tvbet' ? 'tvbet-keno'
                            : _id === 'poker' && provider === 'tvbet' ? 'tvbet-poker'
                            : _id === 'andar-bahar' && provider === 'super-spade' ? 'superspade-andar-bahar'
                            : _id === 'teen-patti-20-20' && provider === 'super-spade' ? 'super-spade-teen-patti-20-20'
                            : _id === 'dragon-tiger' && provider === 'super-spade' ? 'super-spade-dragon-tiger'
                            : _id === 'baccarat' && provider === 'supernowa' ? 'supernowa-baccarat'
                            : _id === 'poker' && provider === 'supernowa' ? 'supernowa-poker'
                            : _id === 'worli-matka' && provider === 'supernowa' ? 'supernowa-worli-matka'
                            : _id === 'akbar-romeo-walter' && provider === 'supernowa' ? 'supernowa-akbar-romeo-walter'
                            : _id === '32-cards' && provider === 'supernowa' ? 'supernowa-32-cards'
                            : _id === 'king-race' && provider === 'supernowa' ? 'supernowa-king-race'
                            : _id === 'andar-bahar' && provider === 'supernowa' ? 'supernowa-andar-bahar'
                            
                            : _id === 'andar-bahar' && provider === 'mplay' ? 'mplay-andar-bahar'
                            : _id === 'jhandi-munda' && provider === 'mplay' ? 'mplay-jhandi-munda'
                            : _id === 'dragon-tiger' && provider === 'mplay' ? 'mplay-dragon-tiger'
                            : _id === 'satta-matka-express' && provider === 'mplay' ? 'mplay-satta-matka-express'
                            : _id === 'andar-bahar' && provider === '7mojos' ? '7mojos-andar-bahar'
                            : _id === 'dragon-tiger' && provider === '7mojos' ? '7mojos-dragon-tiger'
                            : _id === 'teenpatti' && provider ==='ag' ? 'ag-teenpatti'
                            : _id === 'keno' && provider ==='tvbet' ? 'tvbet-keno'
                            : _id === 'teen-patti-20-20' && provider ==='super-spade' ? 'sup-teenpatti2020'
                            : _id === 'dragon-tiger' && provider ==='7mojos' ? '7mojos-dragonTiger'
                            : _id === 'dragon-tiger' && provider ==='mplay' ? 'mplay-dragonTiger'
                            : _id === 'dragon-tiger' ? (provider ==='evolution'? 'evodragonTiger' : 'dragonTiger')
                            : _id === 'teen-patti' && provider ==='evolution' ? 'evo-teenpatti'
                            : _id === 'andar-bahar' && provider ==='kingmaker' ? 'kingmaker-andarbahar'
                            : _id === 'andar-bahar' && provider ==='ezugi' ? 'ezugi-andarbahar'
                            : _id === 'andar-bahar' && provider ==='supernowa' ? 'supernowa-andar-bahar'
                            : _id === 'andar-bahar' && provider ==='mplay' ? 'mplay-andar-bahar'
                            : _id === 'andar-bahar' && provider ==='7mojos' ? '7mojos-andar-bahar'
                            : _id === 'andar-bahar' && provider ==='ag' ? 'ag-andar-bahar'
                            : _id === 'andar-bahar' && provider !=='kingmaker' ? 'andar-bahar'
                            : _id === 'blackjack' && provider ==='ezugi' ? 'ezugiBlackjack'
                            : _id === 'roulette' && provider ==='ezugi' ? 'ezugi-roulette'
                            : _id === 'teen-patti' && provider ==='ezugi' ? 'ezugi-teenpatti'
                            : _id === '32-cards' && provider ==='supernowa' ? 'supernowa-32-cards'
                            : _id === 'baccarat' && provider ==='supernowa' ? 'supernowa-baccarat'
                            : _id === 'baccarat' && provider ==='ag' ? 'ag-baccarat'
                            : _id === 'roulette' && provider ==='ag' ? 'ag-roulette'
                            : _id === 'blackjack' && provider ==='mplay' ? 'mplay-blackjack'
                            : _id === 'sic-bo' && provider ==='mplay' ? 'mplay-sic-bo'
                            : _id === 'super-andar-bahar' ? 'evo-super-andar-bahar'
                            : _id === 'xxx-lightning-roulette' ? 'evo-xxx-lightning-roulette'
                            : _id === 'lightning-storm' ? 'lightning-storm'
                            : _id === 'dragon-tiger-table' ? 'dragon-tiger-table'
                            : _id === 'hindi-lightning-roulette' ? 'evo-hindi-lightning-roulette'
                            : _id === 'hindi-speed-baccarat' ? 'evo-hindi-speed-baccarat'
                            : _id === 'monopoly-big-baller' ? 'evo-monopoly-big-baller'
                            : _id === 'american-roulette' ? 'evo-american-roulette'
                            : _id === 'monopoly' ? 'monopoly'
                            : _id === 'mplay' ? 'livecasino-mplay'
                            : _id === 'baccarat' ? 'live-casino-baccarat'
                            : _id === 'vivo' ? 'livecasino-vivo'
                            : _id === 'sic-bo' ? 'sic-bo'
                            : _id === 'king-race' ? 'king-race'
                            : _id === '32-cards' ? '32-cards'
                            : _id === 'worli-matka' ? 'worli-matka'
                            : _id === 'poker' ? 'poker'
                            : _id === 'winfinity' ? 'winfinity'
                            : _id === "supernowa" ? "supernowa"
                            : _id === "ezugi"  ? "ezugi"
                            : _id === "7mojos" ? "7MOJOS"
                            : _id === "sexy-gaming" ? "sexygaming"
                            : _id === 'macaw' ? 'macaw'
                            : _id === 'tvbet' ? 'tvbet'
                            : _id === 'super-spade' ? 'superspade'
                            : _id === 'ag'  ? 'ag'
                            : _id === 'live-blackjack'  ? "live-blackjack"
                            : _id === 'live-roulette' ? "live-roulette"
                            : _id === 'live-baccarat' ? "live-baccarat"
                            : _id === 'betgames' ? "betgames"
                            : _id === 'crazytime' ? "crazytime" 
                            : _id === 'crazy-time' ? "crazytime" 
                            : _id === 'lightning-roulette' ? "lightningroulette" 
                            : _id === 'monopoly-live' ? "monopolylive"  
                            : _id === 'funky-time' ? "funkytime"
                            : _id === 'lightning-dice' ? "lightningdice"
                            : _id === 'macludo' ? 'macludo'
                            : _id === 'bingo' ? 'bingo'
                            : _id === 'evo' ? 'evo'
                            : _id === 'first person blackjack' ? 'First-Person-Blackjack'                               
                            : _id === 'teenpatti 20 20' ? 'teenpatti2020-2020'
                            : _id === 'dream-catcher' ? 'dream-catcher'
                            : _id === 'hi-lo' ? 'hi-lo'
                            : _id === 'roulette' ? 'live-casino-roulette'
                            
                            : _id === 'mplay' ? 'canio-mplay'
                            : _id
                        }
                    />
                )
            }
            {
                !_id &&  <SEOContents pageName="onlineCasinoGames" />
            }

            {loading ? (
                <Spinner />
            ) : (
                <CasinoWrapper>
                    <TabListSection>
                        <Tabs
                            searchText={search}
                            providerIcons={providerIcons}
                            tabs={providerTab}
                            onSearch={searchData}
                            isTabsHidden={false}
                            budgetClick={budgetData}
                            minWidthInContent={"initial"}
                            providerList={providerList}
                            render={(index: any) => {
                                const selectedProvider = providerList[index];
                                const isAllGames = !selectedProvider || selectedProvider === 'all';

                                const filteredGameData = isAllGames ? filteredData
                                    : filteredData.filter((game) => (game.type || '').toLowerCase() === selectedProvider.toLowerCase());

                                return <AllGames data={filteredGameData} />
                            }}
                        />
                    </TabListSection>
                </CasinoWrapper>
            )}

            {
                getLastqueryString === 'live-blackjack' && showSeoFooterInsidePages ? <BlackjackSEO /> :
                getLastqueryString === 'live-roulette' && showSeoFooterInsidePages ? <RouletteSEO /> :
                getLastqueryString == 'evolution' && showSEOfooterForYolo ? <EvolutionSEO /> :
                _id == 'betgames' && showSEOfooterForYolo ? <BetgamesSEO /> :
                _id == 'supernowa' && showSEOfooterForYolo ? <SUPERNOWASEO /> :
                _id === 'sexy-gaming' && showSEOfooterForYolo ? <SexyGamingSEO /> :
                (provider === 'ezugi' && getLastqueryString === 'dragon-tiger' && showSeofooterFun88) ? <EZUGIDragonTigerFun88 /> :
                (provider === 'ezugi' && getLastqueryString === 'one-day-teen-patti' && showSeofooterFun88) ? <EZUGIoneDayTeenPattiFun88 /> :
                (getLastqueryString === 'ezugi' && showSEOfooterForYolo && (brandId !== 46)) ? <EZUGISEO /> :
                _id === '7MOJOS' && showSEOfooterForYolo ? <Mojos7 /> :
                _id === 'macaw' && showSEOfooterForYolo ? <MACAWSEO /> :
                _id === 'tvbet' && showSEOfooterForYolo && !(brandId == 39 || brandId == 40) ? <TVbetSEO /> :
                _id === 'super-spade' && showSEOfooterForYolo && !(brandId == 39 || brandId == 40) ? <SuperspadeSEO /> :
                _id === "ag" && showSEOfooterForYolo && !(brandId == 39 || brandId == 40) ? <AgSEO /> :
                ((provider === 'evolution' && getLastqueryString === 'dream-catcher') && showSeofooterFun88) ? <DreamCatherf88 /> :
                ((provider === 'evolution' && getLastqueryString === 'dragon-tiger') && showSeofooterFun88) ? <EvolutionDragontigerfun88 /> :
                ((provider === 'evolution' && getLastqueryString === 'funky-time') && showSeofooterFun88) ? <Funkytime88 /> :
                ((getLastqueryString === 'dragon-tiger') && showSeofooterFun88) ? <Dragontigerf88 /> :
                getLastqueryString === 'dragon-tiger' && showSeoFooterInsidePages ? <DragontigerSEO /> :
                getLastqueryString === 'live-baccarat' && showSeoFooterInsidePages ? <BaccaratSEO /> :
                ((provider === 'evolution' && getLastqueryString === 'teen-patti') && showSeofooterFun88) ? <EvolutionTeenpattiFun88 /> :
                ((getLastqueryString === 'teen-patti') && showSeofooterFun88) ? <TeenpattiF88 /> :
                (getLastqueryString === 'teen-patti' && showSEOfooterForYolo && (brandId !== 46)) ? <TeenpattiSEO /> :
                (showSEOfooterForYolo || brandId === 61 || brandId === 33 || brandId === 32) && getLastqueryString === 'live-casino' ? <ONLINECASINOSEO /> :
                ((getLastqueryString === 'lightning-roulette') && showSeofooterFun88) ? <LightningRoulettef88 /> :
                showSEOfooterForYolo && getLastqueryString === 'lightning-roulette' ? <LightningRouletteSEO /> :
                showSEOfooterForYolo && getLastqueryString === 'funky-time' && (brandId == 39 || brandId == 40) ? <FunkyTimeSEO /> : 
                showSEOfooterForYolo && getLastqueryString === 'crazy-time' && (brandId == 39 || brandId == 40) ? <CrazyTimeSEO /> :
                ((getLastqueryString === '7-up-7-down') && showSeofooterFun88) ? <SevenUpDown /> :
                ((provider === 'kingmaker' && getLastqueryString === 'andar-bahar') && showSeofooterFun88) ? <AndarBaharKM46 /> :
                ((provider === 'kingmaker' && getLastqueryString === 'bonus-dice') && showSeofooterFun88) ? <BonusDice46 /> :
                ((provider === 'kingmaker' && getLastqueryString === 'coin-toss') && showSeofooterFun88) ? <CoinToss46 /> :
                ((provider === 'kingmaker' && getLastqueryString === 'color-game') && showSeofooterFun88) ? <Colorgame46 /> :
                ((provider === 'kingmaker' && getLastqueryString === 'jhandi-munda') && showSeofooterFun88) ? <Jhandimunda46 /> :
                ((provider === 'kingmaker' && getLastqueryString === 'triple-chance') && showSeofooterFun88) ? <TripleChance46 /> :
                ((getLastqueryString === 'teenpatti') && showSeofooterFun88) ? <TeenpattiSEO /> :
                ((getLastqueryString === "ag") && showSeofooterFun88) ? <AGseo46 /> :
                ((provider === "betgames" && _id === 'skyward') && showSeofooterFun88) ? <Skywardf88 /> :
                ((provider === "betgames" && _id === 'lucky-7') && showSeofooterFun88) ? <Lucky7f88 /> :
                ((provider === "betgames") && getLastqueryString === 'speedy-7') && showSeofooterFun88 ? <Speedy7Fun88 /> :
                ((provider === "betgames") && getLastqueryString === 'dice-duel') && showSeofooterFun88 ? <DiceDuelFun88 /> :
                ((provider === "betgames") && getLastqueryString === 'satta-matka') && showSeofooterFun88 ? <SattaMatkaFun88 /> :
                ((provider === "betgames") && showSeofooterFun88) ? <Betgamesf88 /> :
                ((getLastqueryString === "playtech") && showSeofooterFun88) ? <PlayTechFun88 /> :
                ((getLastqueryString === 'crazy-time') && showSeofooterFun88) ? <Crazytimef88 /> :
                ((getLastqueryString === 'hindi-lightning-roulette') && showSeofooterFun88) ? <HindiRoulettef88 /> :
                ((getLastqueryString === 'lightning-dice') && showSeofooterFun88) ? <LightningDicef88 /> :
                ((getLastqueryString === 'monopoly-big-baller') && showSeofooterFun88) ? <MonopolyBigballerF88 /> :
                ((getLastqueryString === 'monopoly-live') && showSeofooterFun88) ? <MonolpolyLivef88 /> :
                ((getLastqueryString === 'roulette' && provider === 'evolution') && showSeofooterFun88) ? <RouletteF88 /> :
                ((getLastqueryString === 'roulette' && provider === 'ezugi') && showSeofooterFun88) ? <EzugiRouletteF88 /> :
                ((getLastqueryString === 'super-andar-bahar') && showSeofooterFun88) ? <AndarbaharF88 /> :
                ((getLastqueryString === 'xxxtreme-lightning-roulette') && showSeofooterFun88) ? <XXXtremeRoluetteF88 /> :
                ((getLastqueryString === 'super-spade') && showSeofooterFun88) ? <SuperSpadeFun88 /> :
                ((getLastqueryString === 'teen-patti-20-20') && showSeofooterFun88) ? <TeenPatti2020Fun88 /> :
                ((getLastqueryString === 'andar-bahar') && showSeofooterFun88) ? <AndarBaharFun88 /> :
                ((getLastqueryString === 'american-roulette' && provider === 'evolution') && showSeofooterFun88) ? <AmericanRouletteFun88 /> :
                ((getLastqueryString === 'baccarat' && provider === 'evolution') && showSeofooterFun88) ? <EvolutionBaccaratFun88 /> :
                ((getLastqueryString === 'blackjack' && provider === 'evolution') && showSeofooterFun88) ? <EvolutionBlackjackSeoFun88 /> :
                <></>
            }
        </>
    )
}


export default withAppContext(withTheme(CasinoTabGames));

const CasinoWrapper = styled.div`
    width: 100%;
    display: flex;
    align-items: flex-start;
`;

const TabListSection = styled.div`
    width: 100%;
    display: flex;
    align-items: flex-start;
    
`;
